

import LoadingItem from '../loadingItem';
import './styles.css';

export const Step3ReviewSession = ({
  availableGameTypes,
  selectedGameTypes,
  activeLoadingStep
}) => {
  return (
    <div className='instructor-onboarding step-6'>
      <h2>Thank You for Your Responses!</h2>
      <h3>Hang tight as we build your Review Session!</h3>
      <div className="onboarding-loading-list">
      {
        selectedGameTypes.map((type, index) => (
          <LoadingItem 
            label={availableGameTypes.find(availableGameType => availableGameType.id === type)?.label}
            status={activeLoadingStep > index ? 'completed' : 'loading'} 
            key={index}
          />
        ))
      }
      </div>
    </div>
  )
};